import { Link, NavLink } from "react-router-dom";
import { Leaf } from "lucide-react";

const links = [
  { to: "/", label: "Startseite", testId: "nav-home" },
  { to: "/blog", label: "Blog", testId: "nav-blog" },
  { to: "/ueber-uns", label: "Über uns", testId: "nav-about" },
  { to: "/rechner", label: "Rechner & Tools", testId: "nav-rechner" },
];

export default function Header() {
  return (
    <header
      className="sticky top-0 z-40 bg-white/95 backdrop-blur-sm border-b border-neutral-200"
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 no-underline" data-testid="brand-link">
          <span className="inline-flex items-center justify-center w-9 h-9 bg-brand-primary text-white">
            <Leaf strokeWidth={1.5} size={18} />
          </span>
          <span className="font-serif text-2xl tracking-tight text-brand-dark">Grüne Geldanlage</span>
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={l.testId}
              end={l.to === "/"}
              className={({ isActive }) =>
                `text-sm tracking-wide transition-colors ${
                  isActive ? "text-brand-primary font-medium" : "text-neutral-700 hover:text-brand-primary"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}

          <Link
            to="/admin/login"
            data-testid="nav-admin"
            className="text-xs uppercase tracking-[0.2em] text-neutral-500 hover:text-brand-primary"
          >
            Redaktion
          </Link>
        </nav>

        {/* Mobile - simple list wraps on next line */}
        <nav className="flex md:hidden items-center gap-4 flex-wrap justify-end">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              className="text-sm text-neutral-700"
              data-testid={`${l.testId}-mobile`}
              end={l.to === "/"}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
      </div>
    </header>
  );
}
